var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgSentimentDissatisfied = function SvgSentimentDissatisfied(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#E95D5D",
    clipPath: "url(#sentiment_dissatisfied_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M16.792 11.917a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25ZM9.208 11.917a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M12.99 2.167C7.01 2.167 2.166 7.02 2.166 13s4.842 10.833 10.822 10.833c5.991 0 10.844-4.853 10.844-10.833S18.98 2.167 12.99 2.167Zm.01 19.5A8.664 8.664 0 0 1 4.333 13 8.664 8.664 0 0 1 13 4.333 8.664 8.664 0 0 1 21.667 13 8.664 8.664 0 0 1 13 21.667Zm0-6.5a5.953 5.953 0 0 0-5.547 3.791h1.81A4.317 4.317 0 0 1 13 16.792c1.603 0 2.98.877 3.738 2.166h1.809A5.953 5.953 0 0 0 13 15.167Z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "sentiment_dissatisfied_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
};
export default SvgSentimentDissatisfied;